import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { MST3050_R01DetailDto, MST3050_R01Dto, MST3050_R01HeaderDto } from './Dto_MST3050_R01';
import { MST3050_R01Filter } from "./Store_MST3050_R01";

const baseUrl = `${config.apiUrl}/MST3050_R01`;

const getParams = (filter: Partial<MST3050_R01Filter>, listLength?: number) => {	
	return {
		brandCd: filter.brandCd || '',
		itemGroup: filter.itemGroup || '',
		itemCd: filter.itemCd || '',
		listLength: listLength || 0
	}
}

export const getMST3050_R01List = async (option: string, params: Partial<MST3050_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<MST3050_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getMST3050_R01AllCount = async (params: Partial<MST3050_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getMST3050_R01DetailList = async (salBilNo: string) => {
	const url = `${baseUrl}/detail/${salBilNo}`;

	return await getData<ResponseDto<MST3050_R01DetailDto[]>>(url);
}

export const patchMST3050_R01 = async (data: MST3050_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<MST3050_R01Dto, ResponseDto<MST3050_R01Dto[]>>(url, data);
}

export const deleteMST3050_R01 = async (coordinateCd: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			coordinateCd
		}
	});
}

export const downloadExcel_MST3050_R01 = async (option: string, itemCd: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			itemCd
		}
	})
}
export const getPdfBlob_MST3050_R01 = async (itemCd: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { itemCd },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};